import Vue from 'vue';
import ExtensionsView from '../vue-components/extensions/extensions.vue';

function shipExtensions() {
  new Vue({
    el: '#extensions-view',
    components: {
      'extensions-view': ExtensionsView
    },
    data() {
      return {
        windowCms: window.Cms,
        directions: window.Cms.directionsModel
      };
    }
  });
}
export default shipExtensions;
